import { useEffect, useState } from "react";
import { useAuthenticatedFetch } from "./useAuthenticatedFetch";

export interface ProvinceOption {
  code: string;
  name: string;
}

export function useProvinces(countryCode: string) {
  const authFetch = useAuthenticatedFetch();
  const [result, setResult] = useState<{
    code: string;
    provinces: ProvinceOption[];
  }>({ code: "", provinces: [] });

  useEffect(() => {
    if (!countryCode) return;
    let cancelled = false;

    authFetch(`/api/geocoding/countries/${countryCode}`)
      .then((res) => (res.ok ? res.json() : Promise.reject(res.statusText)))
      .then((data: { provinces: ProvinceOption[] }) => {
        if (!cancelled) {
          setResult({ code: countryCode, provinces: data.provinces ?? [] });
        }
      })
      .catch((err) => {
        console.error("Failed to load provinces:", err);
        if (!cancelled) setResult({ code: countryCode, provinces: [] });
      });

    return () => {
      cancelled = true;
    };
  }, [countryCode, authFetch]);

  const loading = !!countryCode && result.code !== countryCode;
  const provinces = result.code === countryCode ? result.provinces : [];

  return { provinces, loading };
}
